// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6669810c","703":"afc89a70"}[chunkId] + ".chunk.js";
};